import React from "react";
import { Link } from "react-router-dom";
import { buildAuthorPath, buildPublicationPath, buildPublisherPath, slugifyTR } from "../../../../utils/slugify";

const JournalHeaderInfo = ({ meta, parentId, showPublishDate, hidePeople = false }) => {
  if (!meta) return null;
  const { journalTitle, issn, eIssn, accessType, editorTr, editors, audience, webAddress, publishers, authors, publishDate, databases } = meta;

  const formatYear = (dateStr) => {
    if (!dateStr) return "";
    return dateStr.toString().substring(0, 4);
  };

  return (
    <>
      {journalTitle && parentId && (
        <div className="mb-1 d-flex align-items-center">
          <span className="fw-bold text-darkfume me-2" style={{ minWidth: 110 }}>Dergi Adı:</span>
          <span className="text-blue">
            <Link to={buildPublicationPath({ title: journalTitle, id: parentId })} state={{ openTab: "buSayi" }} className="text-blue" style={{ textDecoration: "none" }}>
              {journalTitle}
            </Link>
          </span>
        </div>
      )}

      {!hidePeople && !!(authors?.length) && (
        <div className="mb-1 d-flex align-items-center">
          <span className="fw-bold text-darkfume me-2" style={{ minWidth: 110 }}>Yazar(lar):</span>
          <span className="text-fume">
            {authors.map((a, i) => (
              <React.Fragment key={a.mysqlId || `${a.name}-${a.surname}-${i}`}>
                {a.mysqlId ? (
                  <Link to={buildAuthorPath({ name: a.name, surname: a.surname, id: a.mysqlId })} style={{ textDecoration: "none", color: "#392C7D" }}>
                    {a.name} {a.surname}
                  </Link>
                ) : (<span>{a.name} {a.surname}</span>)}
                {i < authors.length - 1 && ", "}
              </React.Fragment>
            ))}
          </span>
        </div>
      )}

      {editors.length > 0 && (
        <div className="mb-1 d-flex align-items-center">
          <span className="fw-bold me-2 text-darkfume" style={{ minWidth: 110 }}> Editör(ler):</span>
          <span className="text-fume">
            {editors.map((a, i) => (
              <React.Fragment key={a.mysqlId || `${a.name}-${a.surname}-${i}`}>
                {a.mysqlId ? (
                  <Link
                    to={buildAuthorPath({ name: a.name, surname: a.surname, id: a.mysqlId })}
                    style={{ textDecoration: "none", color: "#392C7D" }}
                  >
                    {a.name} {a.surname}
                  </Link>
                ) : (
                  <span>{a.name} {a.surname}</span>
                )}
                {/* DOĞRU KONTROL BURASI: editors.length kullanıldı */}
                {i < editors.length - 1 && ", "}
              </React.Fragment>
            ))}
          </span>
        </div>
      )}

      {!!publishers?.length && (
        <div className="mb-1 d-flex align-items-center">
          <span className="fw-bold text-darkfume me-2" style={{ minWidth: 110 }}>Yayıncı:</span>
          <span className="text-fume">
            {publishers.map((p, i) => (
              <React.Fragment key={p.id || i}>
                <Link to={buildPublisherPath({ title: p.name, id: p.id || "" })} style={{ textDecoration: "none", color: "#392C7D" }}>
                  {p.shortName && p.shortName.trim() ? p.shortName : p.name}
                </Link>
                {i < publishers.length - 1 && ", "}
              </React.Fragment>
            ))}
          </span>
        </div>
      )}

      {issn && (
        <div className="mb-1 d-flex align-items-center">
          <span className="fw-bold text-darkfume me-2" style={{ minWidth: 110 }}>ISSN:</span>
          <span className="text-fume">{issn}</span>
        </div>
      )}

      {/* E-ISSN Bilgisi */}
      {eIssn && (
        <div className="mb-1 d-flex align-items-center">
          <span className="fw-bold text-darkfume me-2" style={{ minWidth: 110 }}>E-ISSN:</span>
          <span className="text-fume">{eIssn}</span>
        </div>
      )}

      {/* {accessType && (
        <div className="mb-1 d-flex align-items-center">
          <span className="fw-bold text-darkfume me-2" style={{ minWidth: 110 }}>Erişim Türü:</span>
          <span className="text-fume">{accessType}</span>
        </div>
      )} */}

      {showPublishDate && publishDate && (
        <div className="mb-1 d-flex align-items-center">
          <span className="fw-bold text-darkfume me-2" style={{ minWidth: 110 }}>Yayın Tarihi:</span>
          <span className="text-fume">{formatYear(publishDate)}</span>
        </div>
      )}

      {Array.isArray(databases) && databases.length > 0 && (
        <div className="mb-1 d-flex align-items-center">
          <span className="fw-bold text-darkfume me-2" style={{ minWidth: 110 }}>Veritabanı:</span>
          <span className="text-fume">
            {(() => {
              const uniqueDbs = databases.map(db => {
                const name = (typeof db === "string" ? db : (db.name || db.title || ""));
                if (name.toLowerCase().includes("akademik dergiler") || name.toLowerCase().includes("popüler dergiler")) {
                  return { name: "İdealonline süreli yayınlar", path: "/journal-list/all" };
                }
                return { name, path: `/database/${slugifyTR(name)}` };
              }).filter((v, i, a) => v.name && a.findIndex(x => x.name === v.name) === i);

              return uniqueDbs.map((db, idx) => (
                <React.Fragment key={db.name}>
                  <Link to={db.path} className="text-blue" style={{ textDecoration: "none" }}>
                    {db.name}
                  </Link>
                  {idx < uniqueDbs.length - 1 && ", "}
                </React.Fragment>
              ));
            })()}
          </span>
        </div>
      )}
    </>
  );
};

export default JournalHeaderInfo;